__turbopack_context__.v({
  "UiPill": "pill-module__aVZ58q__UiPill",
  "UiPill__label": "pill-module__aVZ58q__UiPill__label",
});
